import React from "react";
import HotTable from "react-handsontable";
import axios from "axios";

class MembersImporter extends React.Component {
  state = {
    members: [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ],
    colHeaders: [
      "First Name *",
      "Last Name *",
      "Household ID",
      "Member ID",
      "Date of Birth",
      "Gender",
      "Role",
      "Email",
      "Phone Number",
      "Primary *",
      "Address 1",
      "Address 2",
      "City",
      "State",
      "Zip Code",
      "Notes"
    ]
  };

  importMembers = () => {
    var that = this;

    axios
      .post("/import_members", {
        members: that.state.members
      })
      .then(function(response) {
        toastr.success(
          "Members have been imported, please check your email for confirmation"
        );
      })
      .catch(function(error) {
        toastr.error("Members not imported, check your email for errors");
        console.log(error);
      });
  };

  addRows = () => {
    var rows = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    var members = this.state.members;
    this.setState({ members: members.concat(rows) });
    toastr.success("Rows added");
  };

  reset = () => {
    var members = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    this.setState({ members: members });
    toastr.success("Grid has been cleared");
  };

  render() {
    var that = this;
    const width = { width: "1100px" };

    var columns = [
      {
        data: "firstName",
        type: "text"
      },
      {
        data: "lastName",
        type: "text"
      },
      {
        data: "importedHouseholdId",
        type: "text"
      },
      {
        data: "importedMemberId",
        type: "text"
      },
      {
        data: "dateOfBirth",
        type: "date",
        dateFormat: "MM/DD/YYYY",
        correctFormat: true
      },
      {
        data: "gender",
        type: "dropdown",
        source: ["M", "F"]
      },
      {
        data: "role",
        type: "dropdown",
        source: ["Adult", "Child"]
      },
      {
        data: "email",
        type: "text"
      },
      {
        data: "phoneNumber",
        type: "text"
      },
      {
        data: "primary",
        type: "dropdown",
        source: ["Y", "N"]
      },
      {
        data: "address1",
        type: "text"
      },
      {
        data: "address2",
        type: "text"
      },
      {
        data: "city",
        type: "text"
      },
      {
        data: "state",
        type: "text"
      },
      {
        data: "zipCode",
        type: "text"
      },
      {
        data: "notes",
        type: "text"
      }
    ];

    return (
      <div>
        <h1>Members Importer</h1>
        <p>
          Copy and paste your member data from Excel to add them into
          DigiQuatics. Don't have an Excel file already? Download our template
          <a
            className="styled-link"
            href="/download_excel_template.xlsx?template=members_importer"
          >
            {" "}
            here{" "}
          </a>
          to get started.
        </p>
        <a
          className="btn btn-pink btn-raised btn-long margin-right-five"
          onClick={() => that.importMembers()}
        >
          IMPORT
        </a>
        <a
          className="btn btn-indigo btn-raised btn-long margin-right-five"
          onClick={() => that.addRows()}
        >
          ADD ROWS
        </a>
        <a
          className="btn btn-grey btn-raised btn-long"
          onClick={() => that.reset()}
        >
          RESET
        </a>
        <br />
        <br />
        <HotTable
          root="hot"
          data={this.state.members}
          colHeaders={true}
          rowHeaders={false}
          colWidths={[
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            300
          ]}
          colHeaders={this.state.colHeaders}
          columns={columns}
          width="1100"
          height="320"
        />
      </div>
    );
  }
}

export default MembersImporter;
